import React, { Component } from 'react';
import CompleteTenantRegistration from './completeTenantRegistration';
import { inject, observer } from 'mobx-react';

@inject('configurationsStore') @observer
export default class SetTenantAdminPassword extends Component {

    componentDidMount() {
        this.props.configurationsStore.updateStore();
    }


    render() {
        return this.props.configurationsStore.isMultitenancyMode ?
                <CompleteTenantRegistration requireEula /> :
                null;
    }
}


// WEBPACK FOOTER //
// ./src/components/account/forgotPasswordFlow/setTenantAdminPassword.jsx